export const measurementString = (distance) => {
    const _distance = parseInt(distance, 10);

    if (_distance > 50000) {
        return `${(_distance / 1000).toFixed()}m`;
    } else if (_distance > 10000) {
        return `${(_distance / 1000).toFixed(1)}m`;
    } else if (_distance > 999) {
        return `${(_distance / 1000).toFixed(2)}m`;
    } else {
        return `${_distance}mm`;
    }
};
